<mat-sidenav-container [hasBackdrop]="true" class="sidenav__container">
  <!-- Right-side Sidenav -->
  <mat-sidenav #profileSidenav mode="over" position="end" class="sidenav__container--width">
    <div>
      <!-- The router-outlet for profile popup with deactivate event -->
      <router-outlet name="profilePopup" (deactivate)="profileSidenav.close()"></router-outlet>
    </div>
  </mat-sidenav>

  <!-- Main Application Content -->
  <mat-sidenav-content class="sidenav__content">
    <com-full-page-mask></com-full-page-mask>
    <root-body>
      <com-banner-message location="root" application="elicensing"></com-banner-message>

      <root-header [externalUrl]="externalUrl" [loggedIn]="true" [accountName]="accountName" [isSuperUser]="isAdmin">
        <h1 ngProjectAs="application-name">Sender ID Registry</h1>

        <ng-container ngProjectAs="top-menu">
          @if (loggedIn) {
            @for (item of menuItems; track item) {
              <root-header-nav-item title="{{ item.title }}" [route]="item.url"> </root-header-nav-item>
            }
            <root-header-nav-item title="Home" [showTitle]="false" icon="home" (click)="navigateHome()"> </root-header-nav-item>
            <root-header-nav-item
              title="Account"
              [showTitle]="false"
              icon="account_circle"
              outlet="profilePopup"
              skipLocationChange="true"
              (click)="handleToggleSidenav($event, profileSidenav)"
            >
            </root-header-nav-item>
          }
          @if (loggingIn) {
            <root-header-nav-item title="Cancel Login" (click)="logout()"></root-header-nav-item>
          }
        </ng-container>

        <ng-container ngProjectAs="menu-sub-items">
          <root-header-nav-subitems> </root-header-nav-subitems>
        </ng-container>
      </root-header>

      <div [class]="showLogInBackground ? 'login-background' : 'loggedIn-background'">
        <div class="main-content">
          <div class="visible-content">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>

      <root-footer></root-footer>
    </root-body>
  </mat-sidenav-content>
</mat-sidenav-container>
